































































import { Component, Mixins } from 'vue-property-decorator'
import IconsMixin from '@/mixins/IconsMixin.vue'
import AuthMixin from '@/mixins/AuthMixin.vue'
import { Order, OrderCollection, CompanyStatusEnum, OrderStatusEnum } from 'serverless-firestore'
import { DateService } from '@/services/date.service'

@Component
export default class OrderView extends Mixins(IconsMixin, AuthMixin) {
  public showDelivered: boolean = false
  public isActive: boolean = true
  public orders: Order[] = []
  public headers = [
    { text: '', sortable: false, value: 'icon' },
    { text: 'Order #', value: 'number' },
    { text: 'Status', value: 'status' },
    { text: 'Date Placed', value: 'datePlaced' },
    { text: 'Date Expected', value: 'dateExpected' },
    { text: 'Percent Delivered', value: 'percentDelivered' }
  ]

  public months = DateService.months('abbreviatedMonths')

  public async mounted() {
    this.isActive = this.userCompany.status === CompanyStatusEnum.ACTIVE

    const collection = new OrderCollection(( await this.$firebase ).firestore())
    this.orders = collection.watchOrdersByCompanyId(this.userCompany.id)
  }

  public async viewOrder(order: Order) {
    await this.$router.push({ name: 'order-details', params: { id: order.id } })
  }

  public get displayedOrders() {
    const filtered = this.orders.filter(
      (order) =>
        this.showDelivered
        || !order.isComplete
    )

    return filtered.sort((a: Order, b: Order) => {
      if (a.status === OrderStatusEnum.DRAFT || b.status === OrderStatusEnum.DRAFT) {
        if (a.status === OrderStatusEnum.DRAFT && b.status === OrderStatusEnum.DRAFT) {
          if (!a.dateExpected) {
            return 1
          } else if (!b.dateExpected) {
            return -1
          } else {
            return b.dateExpected.getTime() - a.dateExpected.getTime()
          }
        } else if (a.status === OrderStatusEnum.DRAFT) {
          return -1
        } else if (b.status === OrderStatusEnum.DRAFT) {
          return 1
        }
      }

      if (!a.dateExpected) {
        return 1
      } else if (!b.dateExpected) {
        return -1
      } else {
        return b.dateExpected.getTime() - a.dateExpected.getTime()
      }
    })
  }

  public async createOrder() {
    await this.$router.push({ name: 'order-edit', params: { id: 'create' } })
  }

  public async createParOrder() {
    await this.$router.push({ name: 'par-order-edit', params: { id: 'create' } })
  }

  public convertToHeader(group: number) {
    if(group === 1000001) {
      return 'Drafts'
    } else if(!group || group === 1000000) {
      return 'No Date Found'
    }

    return `${this.months[parseInt(group.toString().slice(4)) - 1]} ${group.toString().slice(0, 4)}`
  }
}
